/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_InvitationsInputs */

const th_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คำเชิญ`)
};

const en_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitations`)
};

const ja_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待`)
};

const zh_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请`)
};

const es_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitaciones`)
};

const pt_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convites`)
};

const id_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undangan`)
};

const fr_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitations`)
};

const tl_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga paanyaya`)
};

const vi_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lời mời`)
};

const ko_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대`)
};

const de_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungen`)
};

const ru_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приглашения`)
};

const tr_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davetler`)
};

const it_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviti`)
};

const pl_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaproszenia`)
};

const uk_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запрошення`)
};

const hi_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निमंत्रण`)
};

const ar_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الدعوات`)
};

const ms_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jemputan`)
};

const bn_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আমন্ত্রণ`)
};

const zh_tw2_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀請`)
};

const zh_hk2_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀請`)
};

const ur_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعوتیں`)
};

const fa_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعوت‌ها`)
};

const sw_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mialiko`)
};

const nl_meeting_invitations = /** @type {(inputs: Meeting_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitnodigingen`)
};

/**
* | output |
* | --- |
* | "Invitations" |
*
* @param {Meeting_InvitationsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_invitations = /** @type {((inputs?: Meeting_InvitationsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_InvitationsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_invitations(inputs)
	if (locale === "ja") return ja_meeting_invitations(inputs)
	if (locale === "zh") return zh_meeting_invitations(inputs)
	if (locale === "es") return es_meeting_invitations(inputs)
	if (locale === "pt") return pt_meeting_invitations(inputs)
	if (locale === "id") return id_meeting_invitations(inputs)
	if (locale === "fr") return fr_meeting_invitations(inputs)
	if (locale === "tl") return tl_meeting_invitations(inputs)
	if (locale === "vi") return vi_meeting_invitations(inputs)
	if (locale === "ko") return ko_meeting_invitations(inputs)
	if (locale === "de") return de_meeting_invitations(inputs)
	if (locale === "ru") return ru_meeting_invitations(inputs)
	if (locale === "tr") return tr_meeting_invitations(inputs)
	if (locale === "it") return it_meeting_invitations(inputs)
	if (locale === "pl") return pl_meeting_invitations(inputs)
	if (locale === "uk") return uk_meeting_invitations(inputs)
	if (locale === "hi") return hi_meeting_invitations(inputs)
	if (locale === "ar") return ar_meeting_invitations(inputs)
	if (locale === "ms") return ms_meeting_invitations(inputs)
	if (locale === "bn") return bn_meeting_invitations(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_invitations(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_invitations(inputs)
	if (locale === "ur") return ur_meeting_invitations(inputs)
	if (locale === "fa") return fa_meeting_invitations(inputs)
	if (locale === "sw") return sw_meeting_invitations(inputs)
	if (locale === "nl") return nl_meeting_invitations(inputs)
	return en_meeting_invitations(inputs)
});